import { useMemo } from 'react';

import { mapAnalysisNiches } from '@/shared/api/mappers/analysis-stats';
import { useGetAnalysisNichesQuery } from '@/shared/hooks/queries/generated';

import type { AnalysisNiche } from '../types';

import { type AnalysisSegment, toSegmentInput } from '@/shared/utils/analysis/segment';

export const useAnalysisNiches = (analysisId: string, segment?: AnalysisSegment) => {
  const { data, isLoading, error } = useGetAnalysisNichesQuery(
    { analysisId, segment: segment ? toSegmentInput(segment) : null },
    {
      enabled: !!analysisId,
      // Snapshot figé à la création : jamais périmé
      staleTime: Infinity,
      gcTime: 30 * 60 * 1000,
    },
  );

  const niches = useMemo((): AnalysisNiche[] => {
    if (!data?.getAnalysisNiches) return [];
    return mapAnalysisNiches(data.getAnalysisNiches);
  }, [data]);

  return {
    niches,
    isLoading,
    error: (error as any)?.message,
  };
};
